import { MenuItem } from "./menu";
import { PopperDelegate } from "../popper/popper";
export class PoppableMenuBinding {
  /** The list of menu items to bind to. */
  public menuItems = "<?";

  /** The display title name for the menu control */
  public menuName = "@";

  /** If set to true, the popped menu will be aligned to the right */
  public rightAligned = "<?";
}

export class PoppableMenuController {
  public rightAligned: boolean;
  public menuItems: MenuItem[];
  private popperDelegateObj: PopperDelegate;
  constructor() {}

  public onPopperInitialized(popperDelegateObj: PopperDelegate) {
    this.popperDelegateObj = popperDelegateObj;
  }

  public collapseMenu() {
    this.popperDelegateObj.close();
  }
}
export const sdPoppableMenu: ng.IComponentOptions = {
  controller: PoppableMenuController,
  transclude: {
    menuTitleTemplate: "?menuTitleTemplate"
  },
  templateUrl: "../ShellCommon/Controls/poppable-menu/poppable-menu.html",
  bindings: <any>new PoppableMenuBinding()
};
